import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AauthService } from '@app/services/aauth.service';
import { AlertCommand, AlertDialog, AlertService, MessageSeverity } from '@app/services/alert.service';
import { ConfigurationService } from '@app/services/configuration.service';
import { LoginComponent } from '@app/components/shared-components/login/login.component';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss']
})

export class MainLayoutComponent implements OnInit {
  public isFlyout = false;
  stickyToasties: number[] = [];

  constructor(
    public authService: AauthService,
    private toastService: ToastrService,
    private alertService: AlertService,
    public configurationService: ConfigurationService,
    public activatedRoute: ActivatedRoute,
    private route: ActivatedRoute
    ) {
    this.route.queryParams.subscribe(async params => {
      const flyout = params['fly'];
      if (flyout === '1') {
        this.isFlyout = true;
      }
    });
   }

  ngOnInit(): void {
    this.alertService.getDialogEvent().subscribe(alert => this.showDialog(alert));
    this.alertService.getMessageEvent().subscribe(message => this.showToast(message));
    this.authService.checkLoggedIn();
  }

  get isUserLoggedIn() {
    let ret = false;
    try {
      ret = this.authService.isLoggedIn;
    } catch (error) {
      console.error(error);
    }

    return ret;
  }

  get FullName() {
   return this.authService.curFullName;
  }
  
  signInOut() {
    if (this.isUserLoggedIn) {
      this.authService.logout();
    }
    this.authService.redirectForLogin();
  }

  isShowHeader() { 
    let result = document.getElementById('navbar-main') == null;
    if (result) {
      const comp = this.activatedRoute.firstChild;
      if (comp !== null) {
        result = comp.component !== LoginComponent;
      }
    }

    return result;
  }

  isShowFooter() {
    return this.isShowHeader();
  }
  
  showToast(alert: AlertCommand) {
    if (alert.operation === 'clear') {
      for (const id of this.stickyToasties.slice(0)) {
        this.toastService.clear(id);
      }

      return;
    }

    switch (alert.message.severity) {
      case MessageSeverity.default: this.toastService.show(alert.message.detail, alert.message.summary); break;
      case MessageSeverity.info: this.toastService.info(alert.message.detail, alert.message.summary); break;
      case MessageSeverity.success: this.toastService.success(alert.message.detail, alert.message.summary); break;
      case MessageSeverity.error: this.toastService.error(alert.message.detail, alert.message.summary); break;
      case MessageSeverity.warn: this.toastService.warning(alert.message.detail, alert.message.summary); break;
      case MessageSeverity.wait: this.toastService.info(alert.message.detail, alert.message.summary); break;
    }
  }
  
  showDialog(alert: AlertDialog): void {
  }
}
